<template>
    <div class="comp-no-data">
        <div class="icon-box">
            <i class="icon-record"></i>
        </div>
        <div class="text-box">
            <slot>暂无数据</slot>
        </div>
    </div>
</template>

<script type="text/babel">
    export default {
        data() {
            return {

            };
        },
        props: {

        },
        methods: {

        }
    }
</script>

<style lang="sass" rel="stylesheet/scss">
    .comp-no-data {
        padding: 64px 0 32px 0;
        text-align: center;
        color: #cccccc;
        .icon-box, .text-box {
            display: inline-block;
            vertical-align: middle;
        }
        .icon-box {
            .icon-record {
                font-size: 32px;
            }
        }
        .text-box {
            margin-left: 4px;
            text-align: left;
            >.row {
                &:first-child {
                    font-size: 14px;
                }
                &:nth-child(2) {
                    font-size: 12px;
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// NoData.vue?6b22839c